// src/api/selectionApi.js
import {$authHost, $host} from "./index"; // Импортируем экземпляры axios из главного index.js

export const sendSelectionMail = async (payload) => {
    try {
        const { data } = await $host.post('/api/selection', payload);
        return data;
    } catch (e) {
        throw e;
    }
};

export const createSelection = async (formData) => {
    const { data } = await $authHost.post('api/selection/create', formData);
    return data;
};

export const fetchOneSelection = async (id) => {
    const { data } = await $host.get('api/selection/' + id);
    return data;
};

export const fetchSelectionRequestOffers = async (requestId) => {
    const { data } = await $authHost.get(
        `api/selection/requests/${requestId}/offers`
    );

    return data;
};

export const createSelectionRequestSiteOffer = async (requestId, payload) => {
    const { data } = await $authHost.post(
        `api/selection/requests/${requestId}/offers/site`,
        payload
    );

    return data;
};

export const createSelectionRequestCustomOffer = async (requestId, formData) => {
    const { data } = await $authHost.post(
        `api/selection/requests/${requestId}/offers/custom`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }
    );

    return data;
};

export const fetchSelectionRequestMyOffers = async (requestId) => {
    const { data } = await $authHost.get(
        `api/selection/requests/${requestId}/offers/my`
    );

    return data;
};

export const fetchOwnerSelectionRequests = async () => {
    const { data } = await $authHost.get(
        'api/selection/requests/owner'
    );

    return data;
};

export const fetchAdminSelectionRequests = async () => {
    const { data } = await $authHost.get(
        'api/selection/requests/admin'
    );

    return data;
};